import { SVGProps } from "react";

export function Ship(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 17.625C0.596737 17.625 1.16903 17.3879 1.59099 16.966C2.01295 16.544 2.25 15.9717 2.25 15.375C2.25 15.9717 2.48705 16.544 2.90901 16.966C3.33097 17.3879 3.90326 17.625 4.5 17.625C5.09674 17.625 5.66903 17.3879 6.09099 16.966C6.51295 16.544 6.75 15.9717 6.75 15.375C6.75 15.9717 6.98705 16.544 7.40901 16.966C7.83097 17.3879 8.40326 17.625 9 17.625C9.59674 17.625 10.169 17.3879 10.591 16.966C11.0129 16.544 11.25 15.9717 11.25 15.375C11.25 15.9717 11.4871 16.544 11.909 16.966C12.331 17.3879 12.9033 17.625 13.5 17.625C14.0967 17.625 14.669 17.3879 15.091 16.966C15.5129 16.544 15.75 15.9717 15.75 15.375C15.75 15.9717 15.9871 16.544 16.409 16.966C16.831 17.3879 17.4033 17.625 18 17.625M4.125 7.67775V2.625H13.875V7.67775M9 0V2.625M4.125 14.25C4.125 14.1195 4.035 13.6725 3.91575 13.143C3.57975 11.64 2.90925 10.2345 2.00325 8.9895L1.875 8.8125V8.625L7.9635 6.0615C8.27067 5.93199 8.53284 5.71478 8.7172 5.43704C8.90156 5.1593 8.99993 4.83336 9 4.5M9 4.5C9 5.18175 9.40875 5.7975 10.0373 6.0615L16.125 8.625V8.8125L15.996 8.9895C15.0907 10.2345 14.4202 11.64 14.0835 13.143C13.9657 13.6718 13.875 14.1195 13.875 14.25M9 4.5V14.25"
        stroke="currentcolor"
        strokeWidth="1"
      />
    </svg>
  );
}
